<template>
  <div class="relative z-0 pt-24 pb-32 bg-fixed bg-black bg-repeat bg-grid-white" id="banner">
    <div class="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black to-transparent h-1/4"></div>

    <div class="px-6 mx-auto max-w-7xl">
      <div class="flex" :class="{ 'justify-center': center }">
        <div class="relative z-10 w-full text-center md:text-left lg:w-1/2" :class="{ 'md:text-center': center }">
          <h1 class="text-5xl font-extrabold leading-none tracking-tight text-white" v-if="title" v-html="title"></h1>
          <p class="mt-5 text-xl text-gray-400" v-if="lead" v-html="lead"></p>
          <slot name="buttons"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SiteBanner',

    props: ['title', 'lead', 'center']
  }
</script>